import { RouteName } from './types'

export class RouteService {
	static getNormalizedRouteName(routeName: string): RouteName {
		const languageSeparator: string = '___'
		return routeName.split(languageSeparator)?.[0] as RouteName
	}
}
